export const firebaseConfig = {
  apiKey: 'AIzaSyDlOD2TASw_N9mfZlXLRkwMYWA_qR1CpH8',
  authDomain: 'play-9c.firebaseapp.com',
  databaseURL: 'https://play-9c.firebaseio.com',
  projectId: 'play-9c',
  storageBucket: 'play-9c.appspot.com',
  messagingSenderId: '765440378742',
  appId: "1:765440378742:web:afff5806f21f27c8cfdc57"
};


// WEBPACK FOOTER //
// ./src/app/fireCreds.ts